import Pusher from 'pusher-js';

export default new Pusher(process.env.REACT_APP_PUSHER_KEY, { cluster: 'mt1' });
